import type { GraphpadWidgetConfig } from '../graphpad.model';

export const QUADRATIC_EXPLORATION_PRESET: GraphpadWidgetConfig = {
  id: 'quadratic-exploration',
  type: 'graphpad',
  params: {
    f: { type: 'quadratic', params: { a: 1, h: 0, k: -4 } },
    'f-translate': { type: 'handle', params: { of: 'f', behavior: 'translate' } },
    'f-roots': { type: 'roots', params: { of: 'f' } },
    'f-derivative': { type: 'derivative', params: { of: 'f' } },
    'f-axis': { type: 'axisOfSymmetry', params: { of: 'f' } },
  },
  display: {
    coordinateSystem: {
      boundingbox: { xStart: -10, xEnd: 10, yStart: -10, yEnd: 10 },
      grid: { type: 'lines', visible: true },
      axes: true,
    },
    elements: {
      f: {
        curve: {
          label: { text: 'f(x)', position: 'topRight' },
        },
      },
      'f-translate': {
        point: {
          label: { text: 'Drag me!', position: 'topRight' },
        },
      },
      'f-roots': {
        point: {
          color: 'indigo',
          label: { contentVariant: 'coord', position: 'bottom', color: 'indigo' },
        },
      },
      'f-derivative': { curve: { color: 'neutral', strokeWidth: 2 } },
      'f-axis': { line: { color: 'amber', dash: 2 } },
    },
  },
};
